export const innerItemHeight = 40;
export const innerItemWidth = 205;
export const itemHeight = 65;
export const itemWidth = 65;
